(function () {
  var UNCAP_SHOP = '1d7874-4.myshopify.com';
  var UNCAP_API = 'https://partsdiagram.uncap.app/api/frontend/getCategory';
  var CACHE_KEY = 'uncapCategoryCache_v2';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000;
  var PAGE_SIZE = 50;
  var MIN_QUERY_LEN = 3;
  var MAX_RESULTS = 3;
  var STYLE_ID = 'uncap-diagram-match-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '.uncap-diagram-match{border:1px solid #f2a25c;background:#fff6ec;border-radius:6px;padding:10px 14px;margin:10px 0;font-size:14px;line-height:1.4}' +
      '.uncap-diagram-match__label{font-weight:600;display:block;margin-bottom:4px;color:#8a4a12}' +
      '.uncap-diagram-match__list{list-style:none;margin:0;padding:0}' +
      '.uncap-diagram-match__list li{margin:2px 0}' +
      '.uncap-diagram-match__list a{color:#c1560c;text-decoration:underline}' +
      '.uncap-diagram-match__list a:hover{color:#8a3d08}' +
      '.uncap-diagram-match--loading{color:#8a4a12;font-style:italic}';
    document.head.appendChild(style);
  }

  function normalize(str) {
    return (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    var al = a.length, bl = b.length;
    if (al === 0) return bl;
    if (bl === 0) return al;
    var prev = new Array(bl + 1);
    for (var j = 0; j <= bl; j++) prev[j] = j;
    for (var i = 1; i <= al; i++) {
      var cur = [i];
      for (var j2 = 1; j2 <= bl; j2++) {
        var cost = a[i - 1] === b[j2 - 1] ? 0 : 1;
        cur[j2] = Math.min(prev[j2] + 1, cur[j2 - 1] + 1, prev[j2 - 1] + cost);
      }
      prev = cur;
    }
    return prev[bl];
  }

  function getCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || (Date.now() - parsed.t) > CACHE_TTL_MS) return null;
      return parsed.data;
    } catch (e) { return null; }
  }

  function setCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data: data }));
    } catch (e) {}
  }

  function fetchPage(page) {
    return fetch(UNCAP_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop: UNCAP_SHOP, pageSize: PAGE_SIZE, page: page })
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).catch(function () { return null; });
  }

  var categoriesPromise = null;
  function loadCategories() {
    if (categoriesPromise) return categoriesPromise;
    var cached = getCache();
    if (cached) {
      categoriesPromise = Promise.resolve(cached);
      return categoriesPromise;
    }
    categoriesPromise = (async function () {
      var all = [];
      try {
        var first = await fetchPage(1);
        var d0 = first && first.data;
        if (!d0 || !d0.categories) return all;
        d0.categories.forEach(function (c) {
          all.push({ id: c.id, title: c.title, norm: normalize(c.title) });
        });
        var totalPages = (d0.pagination && d0.pagination.totalPages) || 1;
        if (totalPages > 1) {
          var pagePromises = [];
          for (var p = 2; p <= totalPages; p++) {
            pagePromises.push(fetchPage(p));
          }
          var results = await Promise.all(pagePromises);
          results.forEach(function (json) {
            var d = json && json.data;
            if (!d || !d.categories) return;
            d.categories.forEach(function (c) {
              all.push({ id: c.id, title: c.title, norm: normalize(c.title) });
            });
          });
        }
      } catch (e) {
        /* fail silently */
      }
      if (all.length) setCache(all);
      return all;
    })();
    return categoriesPromise;
  }

  function findMatches(query, categories) {
    var nq = normalize(query);
    if (nq.length < MIN_QUERY_LEN) return [];
    var scored = [];
    categories.forEach(function (c) {
      if (!c.norm) return;
      var score = null;
      if (c.norm.indexOf(nq) !== -1 || nq.indexOf(c.norm) !== -1) {
        score = Math.abs(c.norm.length - nq.length);
      } else if (nq.length >= 4) {
        var windowLen = Math.min(c.norm.length, nq.length + 3);
        var dist = levenshtein(nq, c.norm.slice(0, windowLen));
        var threshold = nq.length <= 5 ? 1 : 2;
        if (dist <= threshold) score = 10 + dist;
      }
      if (score !== null) scored.push({ cat: c, score: score });
    });
    scored.sort(function (a, b) { return a.score - b.score; });
    var seen = {};
    var out = [];
    for (var i = 0; i < scored.length && out.length < MAX_RESULTS; i++) {
      var id = scored[i].cat.id;
      if (seen[id]) continue;
      seen[id] = true;
      out.push(scored[i].cat);
    }
    return out;
  }

  function renderBox(container, matches) {
    if (!container) return;
    if (!matches.length) {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }
    var html = '<div class="uncap-diagram-match__inner">' +
      '<span class="uncap-diagram-match__label">Parts diagram' + (matches.length > 1 ? 's' : '') + ' found:</span>' +
      '<ul class="uncap-diagram-match__list">' +
      matches.map(function (m) {
        return '<li><a href="/pages/design?id=' + m.id + '&sort=1&page=1">' + m.title + ' → View Diagram</a></li>';
      }).join('') +
      '</ul></div>';
    container.innerHTML = html;
    container.style.display = 'block';
  }

  function renderLoading(container) {
    if (!container) return;
    container.innerHTML = '<span class="uncap-diagram-match--loading">Checking parts diagrams…</span>';
    container.style.display = 'block';
  }

  function ensureContainer(id, referenceSelector, position) {
    var el = document.getElementById(id);
    if (el) return el;
    var ref = document.querySelector(referenceSelector);
    if (!ref || !ref.parentNode) return null;
    el = document.createElement('div');
    el.id = id;
    el.className = 'uncap-diagram-match';
    el.style.display = 'none';
    if (position === 'before') {
      ref.parentNode.insertBefore(el, ref);
    } else {
      ref.parentNode.insertBefore(el, ref.nextSibling);
    }
    return el;
  }

  var queryCounter = 0;
  function handleQuery(query, container) {
    if (!container) return;
    var myToken = ++queryCounter;
    if (!categoriesPromise || !getCache()) {
      renderLoading(container);
    }
    loadCategories().then(function (cats) {
      if (myToken !== queryCounter) return; // a newer query superseded this one
      var matches = findMatches(query, cats);
      renderBox(container, matches);
    });
  }

  function initDrawer() {
    var input = document.querySelector('[data-searchbar__input]');
    if (!input) return;
    var timer;
    input.addEventListener('keyup', function () {
      clearTimeout(timer);
      var val = input.value;
      timer = setTimeout(function () {
        var container = ensureContainer('uncap-diagram-match-drawer', '[data-search-result]', 'before');
        if (val.replace(/\s/g, '').length === 0) {
          queryCounter++;
          if (container) { container.innerHTML = ''; container.style.display = 'none'; }
          return;
        }
        handleQuery(val, container);
      }, 250);
    });
  }

  function initSearchPage() {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    if (!q) return;
    var container = ensureContainer('uncap-diagram-match-page', '.search__content-box', 'before');
    handleQuery(q, container);
  }

  function init() {
    injectStyle();
    loadCategories(); // warm the cache as early as possible
    initDrawer();
    initSearchPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
